import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=579fc7a4&scoped=true"
import script from "./SearchGroup.vue?vue&type=script&lang=js"
export * from "./SearchGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fc7a4",
  null
  
)

export default component.exports